if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"hrs","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return "webpack_sharing_consume_default_vchasno_ui-kit_vchasno_ui-kit" != chunkId},
		rootOutputDir: "../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}